export const defaultCrudValues = {
  briefing: false,
  companyGoals: false,
  persona: false,
  brandPersonality: false,
  editorialTree: false,
  smartGoalDone: false
};
